import * as React from 'react';
export function useMultiSelectMobileModalController(props) {
  const [value, setValue] = React.useState(props.value);
  React.useEffect(() => {
    if (!props.open) {
      setValue(props.value);
    }
  }, [props.value, props.open]);
  const handleOptionChange = React.useCallback(index => {
    const option = props.options[index];
    if (!option) {
      return;
    }
    const optionValue = option.value;
    const prevValue = value || [];
    const isChecked = prevValue.includes(optionValue);
    if (isChecked) {
      setValue(prevValue.filter(v => v !== optionValue));
    } else {
      setValue([...prevValue, optionValue]);
    }
  }, [props.options, value]);
  const handleAllOptionChange = React.useCallback((_, value) => {
    if (value) {
      setValue(props.options.map(option => option.value));
    } else {
      setValue([]);
    }
  }, [props.options]);
  const allOptionLabel = React.useMemo(() => {
    if (!props.allOption) {
      return;
    }
    return typeof props.allOption === 'boolean' ? 'Выбрать всё' : props.allOption;
  }, [props.allOption]);
  return {
    value,
    handleOptionChange,
    handleAllOptionChange,
    allOptionLabel
  };
}